import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { InfoIcon } from "lucide-react"

export function MatchExplainer() {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="inline-flex items-center justify-center rounded-full border bg-background w-5 h-5 cursor-help ml-1">
            <InfoIcon className="h-3 w-3" />
          </div>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <p>
            Instant Match uses AI to analyze your candidate database and find the best matches for this job
            specification.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

